import chameleon from '@chamaeleonidae/chmln';
import { useStore } from '@nanostores/react';
import { useEffect } from 'react';
import { clientFetch } from '~/lib/.client/fetch';
import { errorHandler } from '~/lib/error-handling';
import { initCodeAnalysis } from '~/lib/static-analysis/analyze';
import { userStore } from '~/lib/stores/user';
import { subscribeWebContainerEvents } from '~/lib/webcontainer/events';
import { initChameleonThemeSubscription } from '~/utils/chameleon';
import { logger } from '~/utils/logger';

if (!import.meta.env.VITE_DISABLE_CHAMELEON) {
  chameleon.init('SyZYa5Y29mCMwxhMcyus9FBAg2c6hHDhmrTwyDIdUWKELs-1TYzz7-FOZ7NOdkkssZhWeC', {
    fastUrl: 'https://fast.chameleon.io/',
  });
}

// auto-initialize theme subscription when this module is imported
if (!import.meta.env.SSR) {
  initChameleonThemeSubscription();
}

interface ChameleonResponse {
  uidHash: string;
  userId: string;
}

export function useGlobalInit() {
  const userData = useStore(userStore.user);

  useEffect(() => {
    initCodeAnalysis();
    subscribeWebContainerEvents();
    errorHandler.init();
  }, []);

  useEffect(() => {
    if (import.meta.env.VITE_DISABLE_CHAMELEON) {
      return;
    }

    if (userData) {
      clientFetch('/api/chameleon', {
        method: 'POST',
      })
        .then((response) => response.json<ChameleonResponse>())
        .then((data) => {
          chameleon.identify(data.userId, {
            email: userData.email,
            name: userData.name,
            username: userData.username,
            uid_hash: data.uidHash,
          });
        })
        .catch((error) => {
          logger.error(`Failed to instantiate Chameleon\n\n${error}`);
        });
    }
  }, [userData]);
}
